<template>
  <div id="use-landscape-message">
    <div class="info">
      <h3 class="text-center">Please use landscape mode</h3>
      <img class=mt-5 src="/img/icons/icon-rotate-mobile.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: "UseLandscapeMode"
}
</script>

<style lang="scss" scoped>

#use-landscape-message {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: #ffffff;

  .info {
    position: relative;
    top: calc(50% - 60px);
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);

    h3 {
      font-size: 20px;
      //color: black;
    }

    img {
      display: block;
      margin: 0 auto;
      max-width: 60%;
      height: auto;
    }
  }
}

</style>